<template>
    <li class="sub-channel">
        <div v-bind:class="[current && channel.cid == current.cid ? 'active' : '', clickable && !isAllowed(channel) ? 'disabled' : '', 'ts-channel']" @click="handleFunc(channel)">
            <img src="/assets/icons/ch_red_sub.png" v-if="!channel.flagMaxClientsUnlimited  && channel.maxClients != -1 && (channel.maxClients == 0 || channel.clients >= channel.maxClients)">
            <img src="/assets/icons/ch_yellow_sub.png" v-else-if="channel.flagPassword == 1">
            <img src="/assets/icons/ch_green_sub.png" v-else>

            <span class="label" v-if="clickable && isAllowed(channel)" v-tooltip="'Kliknij, aby zedytować. ID kanału: ' + channel.cid">{{ channel.name }}</span>
            <span class="label" v-else-if="clickable" v-tooltip="'Niedostępny do edycji. ID kanału: ' + channel.cid">{{ channel.name }}</span>
            <span class="label" v-else v-tooltip="'ID kanału: ' + channel.cid">{{ channel.name }}</span>

            <font-awesome-icon v-if="isFunctional()" v-tooltip="'Kanał funkcyjny: ' + getFunctionName()" icon="exclamation-triangle" class="functional"/>
            <font-awesome-icon v-if="handle && isAllowed(channel)" icon="arrows-alt" class="handle" :class="[!isFunctional() ? 'without-functional' : '']"/>
        </div>

        <ul v-if="channel.children && channel.children.length">
            <draggable
                    v-model="channel.children"
                    class="list-group"
                    ghost-class="ghost"
                    @end="checkMove"
                    handle=".handle"
            >
                <channel v-for="child in channel.children" :key="child.cid" :channel="child" :func="func" :current="current" :handle="isParent"></channel>
            </draggable>

            <li class="sub-channel" v-if="addSubChannel">
                <div class="ts-channel add-sub-channel">
                    <button class="btn btn-sm btn-success" @click="addFunc(channel.cid)">
                        <font-awesome-icon icon="plus"/> <span class="label">Dodaj podkanał</span>
                    </button>
                </div>
            </li>
        </ul>
        <ul v-else>
            <li class="sub-channel" v-if="addSubChannel">
                <div class="ts-channel add-sub-channel">
                    <button class="btn btn-sm btn-success" @click="addFunc(channel.cid)">
                        <font-awesome-icon icon="plus"/> <span class="label">Dodaj podkanał</span>
                    </button>
                </div>
            </li>
        </ul>
    </li>
</template>

<script>
    import draggable from "vuedraggable";

    export default {
        name: "Channel",
        components: {
            draggable
        },
        props: {
            channel: Object,
            func: Function,
            addFunc: Function,
            movedFunc: Function,
            current: Object,
            addSubChannel: Boolean,
            clickable: {
                type: Boolean,
                default: function () {
                    return true
                }
            },
            handle: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            isParent: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
        },
        computed: {
            premiumChannel() {
                return this.$store.state.auth.premiumChannel;
            },
        },
        methods: {
            isFunctional() {
              return this.channel.function && this.channel.function != '';
            },
            getFunctionName() {
              return this.channel.function;
            },
            handleFunc(channel) {
              if (this.func && this.isAllowed(channel))
                  this.func(channel.cid);
            },
            isAllowed(channel) {
                return channel.config && channel.config.editable;
            },
            checkMove() {
                this.movedFunc(this.channel.cid, this.channel.children);
            }
        }
    }
</script>

<style scoped>
    .ts-channel{
        cursor: pointer;
        padding: 2px;
    }

    .ts-channel img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }

    .ts-channel.active {
       background: rgba(0,255,0,0.1);
        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    }

    .ts-channel.disabled {
        color: #999;
        cursor: not-allowed;
    }

    .ts-channel.add-sub-channel .btn{
        margin: 0;
        font-size: 0.7rem;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .handle {
        float: right;
        margin-right: 3px;
    }

    .handle.without-functional {
        margin-right: 21px;
    }

    .functional {
        float: right;
    }
</style>